import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const courseCategoryImporterSelectors = importerSelectors(
  'courseCategory.importer',
)

export default courseCategoryImporterSelectors
